import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('city');
const GET_CITIES = define('GET_CITIES', true);
const GET_CITY = define('GET_CITY', true);
const CREATE_CITY = define('CREATE_CITY', true);
const UPDATE_CITY = define('UPDATE_CITY', true);
const PUBLISH_CITY = define('PUBLISH_CITY', true);


const initialState = {
  loadingCities: true,
  cities: [],
  loadingCity: true,
  city: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CITIES.PENDING:
      return {
        ...state,
        loadingCities: true,
        cities: []
      };
    case GET_CITIES.RESOLVED:
      return {
        ...state,
        loadingCities: false,
        cities: action.data
      };
    case GET_CITIES.REJECTED:
      return {
        ...state,
        cities: true,
      };
    case GET_CITY.PENDING:
      return {
        ...state,
        loadingCity: true,
        city: {}
      };
    case GET_CITY.RESOLVED:
      return {
        ...state,
        loadingCity: false,
        city: action.data
      };
    case GET_CITY.REJECTED:
      return {
        ...state,
        loadingCity: true
      };
    default: return state;
  }
};

export const actions = {
  loadCities: () => ({
    type: GET_CITIES,
    promise: api.get('/cities')
  }),
  loadCity: city => ({
    type: GET_CITY,
    promise: api.get(`/cities/${city}`)
  }),
  updateCity: (city, data) => ({
    type: UPDATE_CITY,
    promise: api.put(`/cities/${city}`, data),
    success: 'City has been updated',
    error: 'Unable to update city'
  }),
  createCity: data => ({
    type: CREATE_CITY,
    promise: api.post('/cities', data),
    success: 'City has been created',
    error: 'Unable to create city'
  }),
  publishedCity: (city, publish) => ({
    type: PUBLISH_CITY,
    promise: api.post(`/cities/${city}/publish`, { publish }),
    success: 'City has been published',
    error: 'Unable to published city page',
  })
};



// WEBPACK FOOTER //
// ./src/ducks/city.js